import { Component, OnInit, ViewChild, signal, computed, AfterViewInit, ElementRef } from "@angular/core";
import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { RequisitionService } from '../../services/requisition-service';
import { RequisitionMin } from '../../entites/requisition-min';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, ConfirmationService, SortMeta } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { EnvoiRequisitionComponent } from '../../controles/envoi-requisition.component';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';

@Component({
    templateUrl: './requisitions.component.html',
    styleUrls: ['./requisitions.component.scss'],
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class RequisitionsComponent extends BaseComponent implements OnInit, AfterViewInit {

    requisitions = signal<RequisitionMin[]>([]);
    filteredRequisitions = computed(() => this.requisitions().filter(requisition => {
        if (this.activeIndex() == 0)
            return true;
        else
            return requisition.type.typeRequisitionId == this.activeIndex()
    }));
    selectionRequisition: RequisitionMin;

    detailRequisitionId: number;
    afficherDetailRequisition: boolean = false;

    menuContextuelRequisitions: MenuItem[];

    _activeIndex: number;

    filtreEmplacement: string[];

    tableParams = this.createTableFilter();
    globalFilter: string = '';
    sortMeta: SortMeta[] = [];

    typesRequisition: string[] = [
        "Tous",
        "Réquisitions",
        "Retours",
        "Transferts"
    ]

    activeIndex = signal(0);

    @ViewChild('dt') table: Table;
    @ViewChild('recherche') recherche: ElementRef;


    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private RequisitionsService: RequisitionService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Transports' }
        ]);

        if (
            this.profilService.Profil().roles.some(x => x.nom === 'SIHC_ChargeProjet') &&
            !this.routerService.url.includes('?')
        ) {
            const emplacementsCP = this.sdb.EmplacementsComplet().filter(x =>
                this.profilService.Profil().employe.emplacementIdsCP.includes(x.emplacementId)
            );

            if (emplacementsCP.length > 0) {
                const assignationValues = emplacementsCP.map(x => x.nom);
                const filters = {
                    "a.nom": [
                        {
                            value: assignationValues,
                            matchMode: "in",
                            operator: "and"
                        }
                    ]
                };

                this.routerService.navigate([], {
                    relativeTo: this.route,
                    queryParams: { rows: 100, filters: JSON.stringify(filters) },
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                });
            }
        }
    }

    ngOnInit() {

        this.verifierAccesPage('requisitions');
        ;
        this.colonnesDisponibles = [
            { champ: 'demandeur', entete: 'Demandeur', afficheParDefaut: true },
            { champ: 'camion', entete: 'Camion', afficheParDefaut: false },
            { champ: 'remorque', entete: 'Remorque', afficheParDefaut: false },
            { champ: 'chauffeur', entete: 'Chauffeur', afficheParDefaut: false }
        ];

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.filtreEmplacement = [];
        this.sdb.Emplacements().forEach(x => {
            this.filtreEmplacement.push(x.nom);
        });


        this.RequisitionsService.ObtenirRequisitions().then(x => {
            this.requisitions.set(x.valeur.map(y => {
                let demandeur = y.demandeur;

                if (demandeur) {
                    demandeur.prenomNom = `${demandeur.prenom} ${demandeur.nom}`;
                }
                return {
                    ...y,
                    demandeur: demandeur
                }
            }));

            this.CompleterChargement();

        });
    }

    ngAfterViewInit(): void {
            this.globalFilter = this.tableParams.getValue().globalFilter;
            if(this.tableParams.getValue().multiSortMeta) {
            this.sortMeta = this.tableParams.getValue().multiSortMeta;
        } else {
            this.sortMeta = [
                { field: 'date', order: -1 },
                { field: 'numero', order: -1 }
            ];
        }
        this.chargerColonnesSelectionnees();
    }

    clearFilters(table: Table) {
        table.reset();
        table.clear();
        this.globalFilter = '';
        this.sortMeta = [
            { field: 'date', order: -1 },
            { field: 'numero', order: -1 }
        ];
        this.tableParams.setValue(table);
    }

    OuvrirDetailRequisition(requisitionId: number) {
        this.routerService.navigateByUrl(`transport/${requisitionId}`)
    }

    OuvrirDetailRequisitionNouvelOnglet(requisitionId: number) {
        this.detailRequisitionId = requisitionId;
        this.afficherDetailRequisition = true;
    }

    AjouterRequisition() {
        this.routerService.navigateByUrl('transport/nouveau');
    }

    EnvoyerRequisition(req: RequisitionMin) {
        const ref = this.dialogService.open(EnvoiRequisitionComponent, {
            header: 'Envoi d\'une réquisition',
            width: '50%'
        });
    }

    SupprimerRequisition(req: RequisitionMin) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment supprimer la réquisition #${req.numero}`,
            accept: () => {
                this.requisitions.update(requisitions => requisitions.filter((p) => p.requisitionId !== req.requisitionId));
                this.messageService.add({ severity: 'info', summary: 'Suppression complétée', detail: `Requisition #${req.numero} supprimée` });
                this.selectionRequisition = null;
            }
        });
    }

}
